import "./modules/carousel-slider";
import "./modules/hero-slider";
import "./modules/image-slider";